// Review page - Preview y export

import Alpine from 'alpinejs';
import Swal from 'sweetalert2';

Alpine.data('reviewPage', (meetingId: string) => ({
  meeting: null as { id: string; title: string; client_name: string; objective: string; status: string; started_at: string } | null,
  participants: [] as any[],
  blocks: [] as any[],
  events: [] as any[],
  previewMarkdown: '',
  showPreview: true,

  async init() {
    await this.loadMeetingData();
    await this.refreshPreview();
  },

  async loadMeetingData() {
    // Load from IndexedDB (placeholder)
    this.meeting = { 
      id: meetingId, 
      title: 'Reunión de ejemplo',
      client_name: 'Cliente ABC',
      objective: 'Mejorar proceso de ventas',
      status: 'done',
      started_at: new Date().toISOString(),
    };
    this.participants = [];
    this.blocks = [];
    this.events = [];
  },

  async refreshPreview() {
    // Generate preview using PreviewGenerator (placeholder)
    this.previewMarkdown = `# ${this.meeting?.title || 'Reunión'}

**Cliente:** ${this.meeting?.client_name || 'N/A'}
**Objetivo:** ${this.meeting?.objective || 'N/A'}

## Resumen

Reunión finalizada correctamente.

## Tareas

_No hay tareas registradas_

## Decisiones

_No hay decisiones registradas_

---
_Generado por Meeting BPM Copilot_
`;
  },

  async exportMarkdown() {
    const blob = new Blob([this.previewMarkdown], { type: 'text/markdown' });
    const url = URL.createObjectURL(blob);
    
    const a = document.createElement('a');
    a.href = url;
    a.download = `reunion-${this.meeting?.title.replace(/[^a-z0-9]/gi, '-') || 'export'}.md`;
    a.click();
    
    URL.revokeObjectURL(url);
    
    Swal.fire('Exportado', 'Archivo markdown descargado', 'success');
  },

  async exportJSON() {
    const data = {
      version: '1.0',
      generated_at: new Date().toISOString(),
      meeting: this.meeting,
      participants: this.participants,
      blocks: this.blocks,
      events: this.events,
    };
    
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    
    const a = document.createElement('a');
    a.href = url;
    a.download = `reunion-${this.meeting?.title.replace(/[^a-z0-9]/gi, '-') || 'export'}.json`;
    a.click();
    
    URL.revokeObjectURL(url);
    
    Swal.fire('Exportado', 'Archivo JSON descargado', 'success');
  },

  backToDashboard() {
    window.location.href = '/dashboard';
  },
}));

